export default {
  activeStep: null,
  formRef: null,
  availableSteps: [],
  availableRoutes: {},
  stepperActiveStep: null,
  reopenReport: false,
  refreshReports: false
};
